import { PickingBatchViewRouteService } from 'common/data';
import { findParams } from 'core/utils';
import { BaseService } from 'core/services';

class PickingBatchViewService extends BaseService {
	constructor(apiClient) {
		super(apiClient, new PickingBatchViewRouteService());
	}

	find(filter) {
		var url = this.routeService.find(filter);
		return this.apiClient.post(url, findParams(filter));
	}
}

export default PickingBatchViewService;



// WEBPACK FOOTER //
// ./src/common/data/services/PickingBatchViewService.js